










import Vue from "vue";
import firebase from "firebase";

export default Vue.extend({
  name: "App",
  mounted() {

    firebase.initializeApp({
      apiKey: "AIzaSyAsuxTXQ3paUkUiLUDuUY4-vwFwGCZYpu0",
      authDomain: "firestarter-32c8a.firebaseapp.com",
      databaseURL: "https://firestarter-32c8a.firebaseio.com",
      projectId: "firestarter-32c8a",
      storageBucket: "firestarter-32c8a.appspot.com",
      messagingSenderId: "932394790346",
    });

    const db = firebase.firestore();

    const testObj = {
      name: "Test123" + new Date(),
    };

    db.collection("test").add(testObj).then((result) => console.log("Added", result));

  },
});
